import { useCallback } from 'react'
import { router, usePathname } from 'expo-router'
import { parentPath } from '@utils/parentRoute'

/**
 * Ação do botão de voltar.
 *
 * Com histórico dentro do app, volta pelo histórico — é o que o usuário espera
 * de quem navegou até ali. Sem histórico (tela aberta direto pelo link do
 * painel, link compartilhado, refresh), SUBE um nível na hierarquia com
 * `replace`.
 *
 * O `replace` é o detalhe que importa: empilhar o pai fazia a tela de cima
 * nascer com histórico, e o voltar dela descia de volta para a tela de baixo —
 * pingue-pongue entre aula e curso sem nunca chegar na home.
 */
export function useUpNavigation() {
  const pathname = usePathname()

  return useCallback(() => {
    if (router.canGoBack()) {
      router.back()
      return
    }

    router.replace(parentPath(pathname) ?? '/')
  }, [pathname])
}
